import React, {Component, FunctionComponent} from "react";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import TempAttachmentVO from "../api/gen/qsign/types/TempAttachmentVO";
import ItemListFixed from "./ItemListFixed";

class SeznamPriloh extends React.Component {
    render() {
        const {data} = this.props;
        return (
            <div>
                {data.map((priloha, index) => (
                    <div key={index} className="w-100  border-borders  bb-1 py-3 pl-2 d-flex">
                        <a href={SignRequestInternalApi.downloadRequestAttachment(priloha.uuid)} target="_blank">
                            {priloha.fileName}
                        </a>
                    </div>
                ))}
            </div>
        );
    }
}

export default SeznamPriloh;
